(function( $ ) {
    $(document).ready(function() {
        setupPopovers();
    });
})( window.jQuery );

function setupPopovers()
{
    $('[data-toggle="popover"]').each(function (index) {
        var item = $(this);

        var container = item.attr('popover-container');
        var arguments = {};

        if (container) {
            arguments = {
                'container': container
            };
        }

        $(this).popover(arguments);
    });
}